import styled from 'styled-components';

import ModalHeader from '@/components/Modal/ModalHeader';

export const CustomModalHeader = styled(ModalHeader)`
  display: flex;
  justify-content: flex-end;
  background-color: #f0f2f5;
`;

export const CustomModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
